(window.MobileAccordion = function (Behaviors) {

  "use strict";
  
  function MobileAccordion(elem) {
    Behaviors.init(MobileAccordion, this, arguments)

    this.footer = this.$elem[0]

    this.footer.querySelectorAll('.sf__top-menu-title').forEach(item => {
      item.addEventListener('click', function(){
        item.classList.toggle('sf__top-menu-title--active');

        if(document.querySelector('.sf__top-menu-menu--active') && !item.parentNode.querySelector('.sf__top-menu-menu').classList.contains('sf__top-menu-menu--active')) {
          document.querySelector('.sf__top-menu-menu--active').classList.remove('sf__top-menu-menu--active');
        }
        item.parentNode.querySelector('.sf__top-menu-menu').classList.toggle('sf__top-menu-menu--active');
      });
    });

  }

  Behaviors.inherit(MobileAccordion, Behaviors.Behavior);
  MobileAccordion.QUERY = '.site-footer';

  Behaviors.register_behavior(MobileAccordion);
  
  return MobileAccordion;

  }(window.Behaviors));